






















































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import router from '@/router'
import Statistics from '@/components/Statistics.vue'
import ChainInfo from '@/components/ChainInfo.vue'
import accounts from '@/store/modules/accounts'
import {
	ARBITRUM_MAINNET,
	BSC_MAINNET,
	ETHEREUM_MAINNET,
	FANTOM_MAINNET,
	POLYGON_MAINNET,
	Network,
} from '@/utils/Networks'

const banStore = namespace('ban')
const accountsStore = namespace('accounts')

@Component({
	components: {
		Statistics,
		ChainInfo,
	},
})
export default class PageIndex extends Vue {
	@accountsStore.State('network')
	currentBlockchain!: Network

	@accountsStore.Getter('isUserConnected')
	isUserConnected!: boolean

	@banStore.Getter('banAddress')
	banAddress!: string

	@Watch('isUserConnected')
	redirect() {
		console.log('in redirect')
		if (this.isUserConnected && (!this.banAddress || this.banAddress === '')) {
			if (router.currentRoute.path !== '/setup') {
				router.push('/setup')
			}
		} else {
			console.debug(`BAN address: ${this.banAddress}`)
		}
	}

	async connectWalletProvider(wanted: 'bsc' | 'polygon' | 'fantom' | 'ethereum' | 'arbitrum' | undefined) {
		let wantedChain = undefined
		if (wanted === 'bsc') {
			wantedChain = BSC_MAINNET.chainId
		} else if (wanted === 'polygon') {
			wantedChain = POLYGON_MAINNET.chainId
		} else if (wanted === 'fantom') {
			wantedChain = FANTOM_MAINNET.chainId
		} else if (wanted === 'ethereum') {
			wantedChain = ETHEREUM_MAINNET.chainId
		} else if (wanted === 'arbitrum') {
			wantedChain = ARBITRUM_MAINNET.chainId
		}
		console.warn('Wanted chain', wantedChain)
		await accounts.initWalletProvider()
		await accounts.connectWalletProvider(wantedChain)
	}
}
